import { GroupMember } from '@ih/app/shared/apis/interfaces';

export class FindAllGroupPermissionsAction {
  public static readonly type = '[Authorisation] FindAllGroupPermissionsAction';
  constructor(public readonly groupMembers: GroupMember[]) {}
}
